<div
    class="result-content"
    [ngStyle]="{
        height:
            (result.status === 'Inactive' || result.status === 'Active (Pending)') && result.soldDate
                ? '110px'
                : 'auto',
    }"
>
    <h4 class="m-0 fw-bold">{{ result.siteName }}</h4>
    <strong>{{ result.siteCity }}, {{ result.siteState }}</strong>
    <p class="mb-0">{{ result.companyName }}</p>
    <p class="mb-0">Company ID: {{ result.companyID }}</p>
</div>
<div class="site-status-fields">
    <!-- Inactive Flag -->
    @if (result.status === 'Inactive') {
        <img src="/images/inactive.jpg" alt="Inactive" class="status-img" />
    }
    <!-- Active Pending Flag -->
    @if (result.status === 'Active (Pending)') {
        <img src="/images/active-pending.jpg" alt="Active (Pending)" class="status-img" />
    }
    <!-- Sold Flag -->
    @if (result.soldDate) {
        <img
            [ngStyle]="{
                'margin-top': result.status === 'Inactive' || result.status === 'Active (Pending)' ? '40px' : '0px',
            }"
            src="/images/sold.png"
            alt="Sold"
            class="status-img"
        />
    }
</div>
